import React from 'react';
import { Card, CardContent, Typography, Stack } from '@mui/material';
import EntryCard from './EntryCard';

export const EntryList = ({ goalEntries, isCategorical, goalData }) => {
  return (
    <>
      {goalEntries?.length > 0 && (
        <Card>
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Recent Entries
            </Typography>
            <Stack spacing={2}>
              {goalEntries?.map((entry) => (
                <EntryCard
                  key={entry.id}
                  entry={entry}
                  isCategorical={isCategorical}
                  goalData={goalData}
                />
              ))}
            </Stack>
          </CardContent>
        </Card>
      )}
    </>
  );
};
